/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const STATE = feature.getSettingValue('STATE');
    const PULL = feature.getSettingValue('PULL');
    const dtsName = `${NAME}_gpio`;

    const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    let peripheralPort = '0';
    let gpioNum: string | undefined = '0';
    if (peripherals) {
        peripheralPort = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
        gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].num;
    }

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        id: '#include <zephyr/drivers/gpio.h>',
        template: '#include <zephyr/drivers/gpio.h>',
    });

    blocks.push({
        location: 'APP_OVERLAY_DTS',
        blockType: BlockType.CODE,
        id: 'zephyr_app_overlay_leds',
        template: `
gpio_custom_leds {
    compatible = "gpio-leds";
    /****zephyr_app_overlay_leds****/
};`,
    });

    blocks.push({
        location: 'GLOBAL_DEFINES',
        blockType: BlockType.CODE,
        template: `
#if !DT_NODE_EXISTS(DT_NODELABEL(${dtsName}))
#error "Overlay for ${dtsName} node not properly defined."
#endif
        `,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
static const struct gpio_dt_spec ${dtsName} =
    GPIO_DT_SPEC_GET_OR(DT_NODELABEL(${dtsName}), gpios, {0});
        `,
    });

    let pullCode = '';
    if (PULL === 'up') {
        pullCode = ' | GPIO_PULL_UP';
    } else if (PULL === 'down') {
        pullCode = ' | GPIO_PULL_DOWN';
    }

    const gpioFeature: any = feature;
    const nodePropertiesLocation = 'zephyr_app_overlay_leds';
    const nodeProperties = `
    ${dtsName}:${dtsName} {
        gpios = <&${peripheralPort} ${gpioNum} ${gpioFeature.getFlags()}>;
    };
    `;

    // output
    // blocks.push({
    //     location: 'VARIABLE_DECLARATIONS',
    //     blockType: BlockType.CODE,
    //     template: `${NAME}_pin = machine.Pin(${gpioNum}, machine.Pin.OUT)`,
    // });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `gpio_pin_configure_dt(&${dtsName}, GPIO_OUTPUT_ACTIVE);`,
    });

    blocks.push({
        location: nodePropertiesLocation,
        blockType: BlockType.CODE,
        template: nodeProperties,
    });

    blocks.push({
        location: `var_${NAME}_set`,
        blockType: BlockType.CODE,
        template: `gpio_pin_set_dt(&${dtsName}, value);`,
    });


    return blocks;
};
